import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FileDown } from "lucide-react";
import { api, API } from "@/lib/api";
import { PageHero } from "@/components/Section";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/brands").then((r) => setBrands(r.data)); }, []);
  return (
    <div data-testid="brands-page">
      <PageHero tag="Brand collection" title="Real brands." accent="More possibilities." image="/brands/portfolio.jpg">
        ShelfReady AI gives buyers access to a growing portfolio across multiple consumer categories through one distribution relationship.
        <div className="mt-6"><a href={`${API}/catalog/sell-sheet.pdf`} target="_blank" rel="noreferrer" className="sr-btn-primary" data-testid="catalog-deck-download"><FileDown size={16} /> Download full catalog (PDF)</a></div>
      </PageHero>
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16 space-y-8">
        {brands.map((b, i) => (
          <Link key={b.slug} to={`/brands/${b.slug}`} data-testid={`brand-row-${b.slug}`} className={`sr-card sr-lift overflow-hidden grid md:grid-cols-12 group ${i % 2 ? "md:[&>*:first-child]:order-2" : ""}`}>
            <div className="md:col-span-7 aspect-[16/8] md:aspect-auto overflow-hidden">
              <img src={b.image} alt={b.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
            </div>
            <div className="md:col-span-5 p-8 flex flex-col justify-center">
              <p className="text-[11px] uppercase tracking-[0.2em] font-semibold" style={{ color: b.accent }}>{b.category} · {b.product_count} products</p>
              <h2 className="mt-2 text-3xl font-extrabold uppercase text-[#0B1F4B]">{b.name}</h2>
              <p className="text-sm font-semibold text-slate-500 mt-1">{b.tagline}</p>
              <p className="mt-4 text-sm text-slate-600 leading-relaxed line-clamp-4">{b.description}</p>
              <div className="mt-5 flex flex-wrap gap-2">{b.highlights.slice(0, 4).map((h) => <span key={h} className="text-[11px] rounded-full bg-[#EBF3FE] text-[#1E40AF] px-2.5 py-1 font-medium">{h}</span>)}</div>
              <div className="mt-6 flex items-center gap-5">
                <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#1E7CF2]">View brand portfolio <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" /></span>
                <a href={`${API}/brands/${b.slug}/sell-sheet.pdf`} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-[#0B1F4B]" data-testid={`brand-sell-sheet-${b.slug}`}><FileDown size={15} /> Sell sheet</a>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
